// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"12f7cf00","801":"c3e806cb","999":"230d486e"}[chunkId] + ".chunk.js";
};